var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import MetricServiceResource, { AnalysisTemplateTypeDto } from "@ane/exp-data/lib/resources/MetricServiceResource";
import AnalysisResource from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import * as _ from "lodash";
import FeatureResourcesInstance from "@ane/exp-data/lib/resources/FeatureResources";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const parseAnalysisTemplates = (input) => {
  var _a;
  var analysisTemplates = [];
  (_a = input == null ? void 0 : input.AnalysisRules) == null ? void 0 : _a.forEach((rule) => {
    var _a2;
    analysisTemplates = analysisTemplates.concat((_a2 = rule.SelectedAnalysisTemplates) != null ? _a2 : []);
  });
  analysisTemplates = Array.from(new Set(analysisTemplates));
  return analysisTemplates;
};
const parseValidAnalysisTempaltes = (mdsAnalysisConfigData, metricsAnalysisTemplates, analysisGroup, assignmentUnit = "") => {
  let analysisTemplateNames = [];
  if (analysisGroup) {
    const analysisGroupTemplateNames = getAnalysisGroupTemplateNames(analysisGroup);
    analysisGroupTemplateNames.forEach((name) => {
      if (templateExistsInMetricService(name, metricsAnalysisTemplates)) {
        analysisTemplateNames.push(name);
      }
    });
  }
  const { AnalysisRules = [] } = mdsAnalysisConfigData != null ? mdsAnalysisConfigData : {};
  AnalysisRules.forEach((current) => {
    var _a;
    const { Condition = {}, SelectedAnalysisTemplates = [] } = current;
    const includeAnalysisTemplate = !!!assignmentUnit || !(Condition == null ? void 0 : Condition.AssignmentUnits) || !(Condition == null ? void 0 : Condition.AssignmentUnits.length) || ((_a = Condition == null ? void 0 : Condition.AssignmentUnits) != null ? _a : []).includes(assignmentUnit);
    if (includeAnalysisTemplate) {
      SelectedAnalysisTemplates.forEach((s) => {
        if (templateExistsInMetricService(s, metricsAnalysisTemplates)) {
          analysisTemplateNames.push(s);
        }
      });
    }
  });
  return Array.from(new Set(analysisTemplateNames));
};
const getAnalysisGroupTemplateNames = (analysisGroups) => {
  const analysisTemplateNames = /* @__PURE__ */ new Set();
  analysisGroups.forEach((group) => {
    var _a;
    (_a = group.analysisList) == null ? void 0 : _a.forEach((template) => {
      if (template.isActive && template.name) {
        analysisTemplateNames.add(template.name);
      }
    });
  });
  return Array.from(analysisTemplateNames);
};
function templateExistsInMetricService(templateName, metricsAnalysisTemplates) {
  var _a;
  const analysisTemplate = (_a = metricsAnalysisTemplates == null ? void 0 : metricsAnalysisTemplates[templateName]) == null ? void 0 : _a[ReducerKeys.analysisTemplates];
  return !!(analysisTemplate && analysisTemplate.data && !analysisTemplate.error && analysisTemplate.data.analysisType !== AnalysisTemplateTypeDto.SeedFinder);
}
const setMetricsAnalysisTemplatesInReduxWhenLoading = (state = defaultReducerState, input) => {
  var _a;
  let returnObj = __spreadValues({}, state[ReducerKeys.metricsAnalysisTemplates]);
  const templates = _.split((_a = input == null ? void 0 : input.templateName) != null ? _a : "", ",");
  _.forEach(templates, (templateName) => {
    var _a2, _b, _c;
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [templateName]: {
        [ReducerKeys.analysisTemplates]: __spreadProps(__spreadValues({}, (_c = (_b = (_a2 = state == null ? void 0 : state[ReducerKeys.metricsAnalysisTemplates]) == null ? void 0 : _a2[input.templateName]) == null ? void 0 : _b[ReducerKeys.analysisTemplates]) != null ? _c : getDefaultAsyncWrapperObj()), {
          status: AsyncRequestStatus.Pending
        })
      }
    });
  });
  return returnObj;
};
const setMetricsAnalysisTemplatesInReduxWhenLoaded = (state = defaultReducerState, resultTemplates, asyncData) => {
  let returnObj = __spreadValues({}, state[ReducerKeys.metricsAnalysisTemplates]);
  _.forEach(resultTemplates, (template) => {
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [template.name]: { [ReducerKeys.analysisTemplates]: __spreadProps(__spreadValues({}, asyncData), { data: template }) }
    });
  });
  let availableTemplateNames = resultTemplates.map((rt) => rt.name);
  let requestedTemplateNames = Object.keys(returnObj);
  let unavailableTemplateNames = requestedTemplateNames.filter((requestedTemplate) => {
    var _a, _b;
    const isNotAvailable = !availableTemplateNames.includes(requestedTemplate);
    const isPending = ((_b = (_a = state[ReducerKeys.metricsAnalysisTemplates][requestedTemplate]) == null ? void 0 : _a[ReducerKeys.analysisTemplates]) == null ? void 0 : _b.status) === AsyncRequestStatus.Pending;
    return isNotAvailable && isPending;
  });
  _.forEach(unavailableTemplateNames, (unavailableTemplateName) => {
    returnObj = __spreadProps(__spreadValues({}, returnObj), {
      [unavailableTemplateName]: {
        [ReducerKeys.analysisTemplates]: {
          status: AsyncRequestStatus.Failed,
          data: null,
          error: unavailableTemplateName + " is not valid. Please open a DRI ticket to get help in addressing the issue."
        }
      }
    });
  });
  return returnObj;
};
var ReducerKeys = /* @__PURE__ */ ((ReducerKeys2) => {
  ReducerKeys2["searchMetrics"] = "search_metrics";
  ReducerKeys2["analysisTemplates"] = "analysis_templates";
  ReducerKeys2["loadHypothesis"] = "load_hypothesis";
  ReducerKeys2["putHypothesis"] = "put_hypothesis";
  ReducerKeys2["getExperimentationGroup"] = "get_experimentationgroup";
  ReducerKeys2["queryMetrics"] = "query_metrics";
  ReducerKeys2["metricsAnalysisTemplates"] = "metrics_analysistemplates";
  ReducerKeys2["loadFeature"] = "load_feature";
  ReducerKeys2["analysisGroup"] = "analysis_group_async";
  return ReducerKeys2;
})(ReducerKeys || {});
const defaultReducerState = {
  [
    "search_metrics"
    /* searchMetrics */
  ]: getDefaultAsyncWrapperObj(),
  [
    "analysis_templates"
    /* analysisTemplates */
  ]: getDefaultAsyncWrapperObj(),
  [
    "load_hypothesis"
    /* loadHypothesis */
  ]: getDefaultAsyncWrapperObj(),
  [
    "put_hypothesis"
    /* putHypothesis */
  ]: getDefaultAsyncWrapperObj(),
  [
    "get_experimentationgroup"
    /* getExperimentationGroup */
  ]: getDefaultAsyncWrapperObj(),
  [
    "query_metrics"
    /* queryMetrics */
  ]: getDefaultAsyncWrapperObj(),
  // [ReducerKeys.loadFeatureAutoTriggerState]: getDefaultAsyncWrapperObj<IFeatureAutoTriggerStateResponse>(),
  [
    "metrics_analysistemplates"
    /* metricsAnalysisTemplates */
  ]: {},
  [
    "load_feature"
    /* loadFeature */
  ]: getDefaultAsyncWrapperObj(),
  [
    "analysis_group_async"
    /* analysisGroup */
  ]: getDefaultAsyncWrapperObj()
};
const prefix = "HYPOTHESIS";
const CLEAR_QUERY_METRICS_ACTION = `${prefix}/CLEAR_QUERY_METRICS`;
const clearQueryMetricsRequest = (featureId) => {
  return {
    type: CLEAR_QUERY_METRICS_ACTION
  };
};
const getExperimentationGroupEpicReducerArgs = {
  actionPrefix: `${prefix}/GET_EXPERIMENT`,
  reduxKeyNested: () => [
    "get_experimentationgroup"
    /* getExperimentationGroup */
  ],
  loadResource: (input) => MdsDataplaneResources.getExperimentationGroupV2(input.workspaceId, input.path),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    loadAnalysisTemplatesEpicReducer.actionCreators.load({
      query: "",
      request: {
        workspaceId: inputPayload.workspaceId,
        experimentationGroup: outputPayload.ID,
        section: "AnalysisConfig"
      }
    })
  ]
};
const getExperimentationGroupEpicReducer = loadResourcesUtils(getExperimentationGroupEpicReducerArgs);
const createOrUpdateHypothesisEpicReducerArgs = {
  actionPrefix: `${prefix}/PUT_HYPOTHESIS`,
  reduxKeyNested: () => [
    "put_hypothesis"
    /* putHypothesis */
  ],
  loadResource: (input) => AnalysisResource.createOrUpdateHypothesis(input.workspaceId, input.featureId, input.hypothesis),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const createOrUpdateHypothesisEpicReducer = loadResourcesUtils(createOrUpdateHypothesisEpicReducerArgs);
const loadHypothesisEpicReducerArgs = {
  actionPrefix: `${prefix}/LOAD_HYPOTHESIS`,
  reduxKeyNested: () => [
    "load_hypothesis"
    /* loadHypothesis */
  ],
  loadResource: (input) => AnalysisResource.getHypothesis(input.workspaceId, input.featureId),
  onCompleteSuccess: (resourceResult) => {
    return resourceResult.value;
  }
};
const loadHypothesisEpicReducer = loadResourcesUtils(loadHypothesisEpicReducerArgs);
const metricsEpicReducerArgs = {
  actionPrefix: `${prefix}/LOAD_METRICS`,
  reduxKeyNested: () => [
    "search_metrics"
    /* searchMetrics */
  ],
  loadResource: (data) => {
    return MetricServiceResource.getMetrics(data.workspaceId, data.query, data.analysisTemplates);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const loadMetricsEpicReducer = loadResourcesUtils(metricsEpicReducerArgs);
const analysisTemplatesEpicReducerArgs = {
  actionPrefix: `${prefix}/LOAD_ANALYSIS_TEMPLATES`,
  reduxKeyNested: () => [
    "analysis_templates"
    /* analysisTemplates */
  ],
  loadResource: (input) => MdsDataplaneResources.getConfigWithTypeV2(input.request),
  onCompleteSuccess: (resourceResult, inputPayload) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    const actions = [];
    if (EnvironmentService.enableHypothesisTemplateFiltering()) {
      actions.push(
        loadMetricsAnalysisTemplateEpicReducer.actionCreators.load({
          workspaceId: inputPayload.request.workspaceId,
          templateName: parseAnalysisTemplates(outputPayload).join(",")
        })
      );
    }
    actions.push(
      loadMetricsEpicReducer.actionCreators.load({
        workspaceId: inputPayload.request.workspaceId,
        query: inputPayload.query,
        analysisTemplates: parseAnalysisTemplates(outputPayload)
      })
    );
    return actions;
  }
};
const loadAnalysisTemplatesEpicReducer = loadResourcesUtils(analysisTemplatesEpicReducerArgs);
const queryMetricsEpicReducerArgs = {
  actionPrefix: `${prefix}/QUERY_METRICS`,
  reduxKeyNested: () => [
    "query_metrics"
    /* queryMetrics */
  ],
  loadResource: (data) => {
    return MetricServiceResource.getMetrics(data.workspaceId, data.query, data.analysisTemplates);
  },
  onCompleteSuccess: (resourceResult) => {
    return resourceResult;
  }
};
const queryMetricsEpicReducer = loadResourcesUtils(queryMetricsEpicReducerArgs);
const loadMetricsAnalysisTemplateArgs = {
  actionPrefix: `${prefix}/LOAD_METRICS_ANALYSIS_TEMPLATE`,
  reduxKeyNested: (inputPayload) => [
    "metrics_analysistemplates",
    inputPayload.templateName,
    "analysis_templates"
    /* analysisTemplates */
  ],
  loadResource: (data) => MetricServiceResource.getAnalysisTemplate(data.workspaceId, data.templateName),
  onCompleteSuccess: (result) => result,
  dontLoad(inputPayload, state) {
    return state.hypothesis_module.create[
      "metrics_analysistemplates"
      /* metricsAnalysisTemplates */
    ][inputPayload.templateName] ? [AsyncRequestStatus.Completed, AsyncRequestStatus.Pending, AsyncRequestStatus.Failed].includes(
      state.hypothesis_module.create[
        "metrics_analysistemplates"
        /* metricsAnalysisTemplates */
      ][inputPayload.templateName][
        "analysis_templates"
        /* analysisTemplates */
      ].status
    ) : false;
  }
};
const loadMetricsAnalysisTemplateEpicReducer = loadResourcesUtils(loadMetricsAnalysisTemplateArgs);
const loadRootFeatureArgs = {
  actionPrefix: `${prefix}/LOAD_FEATURE`,
  reduxKeyNested: () => [
    "load_feature"
    /* loadFeature */
  ],
  loadResource: (data) => FeatureResourcesInstance.loadRootFeatureV2(data.featureId),
  onCompleteSuccess: (resuresourceResult) => {
    return resuresourceResult;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    var _a, _b, _c;
    const { WorkspaceId: workspaceId } = outputPayload;
    const experimentStepId = (_c = (_b = (_a = outputPayload.Phases) == null ? void 0 : _a[0]) == null ? void 0 : _b.StepIds) == null ? void 0 : _c[0];
    return !!experimentStepId ? [loadAnalysisGroupEpicReducer.actionCreators.load({ workspaceId, experimentStepId })] : [];
  }
};
const loadRootFeatureEpicReducer = loadResourcesUtils(loadRootFeatureArgs);
const loadAnalysisGroupArgs = {
  actionPrefix: `${prefix}/LOAD_ANALYSIS_GROUP`,
  reduxKeyNested: () => [
    "analysis_group_async"
    /* analysisGroup */
  ],
  loadResource: (payload) => AnalysisResource.getAnalysisGroup(payload.workspaceId, payload.experimentStepId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    loadMetricsAnalysisTemplateEpicReducer.actionCreators.load({
      workspaceId: inputPayload.workspaceId,
      templateName: getAnalysisGroupTemplateNames(outputPayload.value).join(",")
    })
  ]
};
const loadAnalysisGroupEpicReducer = loadResourcesUtils(loadAnalysisGroupArgs);
const reducer = (state = defaultReducerState, action) => {
  var _a, _b;
  state = createOrUpdateHypothesisEpicReducer.reduxChange(state, action);
  state = loadMetricsEpicReducer.reduxChange(state, action);
  state = loadAnalysisTemplatesEpicReducer.reduxChange(state, action);
  state = loadHypothesisEpicReducer.reduxChange(state, action);
  state = getExperimentationGroupEpicReducer.reduxChange(state, action);
  state = queryMetricsEpicReducer.reduxChange(state, action);
  state = loadRootFeatureEpicReducer.reduxChange(state, action);
  state = loadAnalysisGroupEpicReducer.reduxChange(state, action);
  if (action.type === CLEAR_QUERY_METRICS_ACTION) {
    return __spreadProps(__spreadValues({}, state), {
      query_metrics: getDefaultAsyncWrapperObj()
    });
  }
  if (action.type === `${prefix}/LOAD_METRICS_ANALYSIS_TEMPLATE/LOADING`) {
    state = __spreadProps(__spreadValues({}, state), {
      [
        "metrics_analysistemplates"
        /* metricsAnalysisTemplates */
      ]: __spreadValues({}, setMetricsAnalysisTemplatesInReduxWhenLoading(state, action.payload))
    });
  }
  if (action.type === `${prefix}/LOAD_METRICS_ANALYSIS_TEMPLATE/LOADED`) {
    state = __spreadProps(__spreadValues({}, state), {
      [
        "metrics_analysistemplates"
        /* metricsAnalysisTemplates */
      ]: __spreadValues({}, setMetricsAnalysisTemplatesInReduxWhenLoaded(state, (_b = (_a = action.outputPayloadAsync) == null ? void 0 : _a.data) != null ? _b : [], action.outputPayloadAsync))
    });
  }
  return state;
};
export {
  ReducerKeys as R,
  createOrUpdateHypothesisEpicReducer as a,
  loadMetricsEpicReducer as b,
  clearQueryMetricsRequest as c,
  defaultReducerState as d,
  loadAnalysisTemplatesEpicReducer as e,
  loadMetricsAnalysisTemplateEpicReducer as f,
  getExperimentationGroupEpicReducer as g,
  loadRootFeatureEpicReducer as h,
  loadAnalysisGroupEpicReducer as i,
  parseAnalysisTemplates as j,
  getAnalysisGroupTemplateNames as k,
  loadHypothesisEpicReducer as l,
  setMetricsAnalysisTemplatesInReduxWhenLoaded as m,
  parseValidAnalysisTempaltes as p,
  queryMetricsEpicReducer as q,
  reducer as r,
  setMetricsAnalysisTemplatesInReduxWhenLoading as s
};
//# sourceMappingURL=Create.ducks-09e3d573.js.map
